import React from 'react';
import './LanguageSelect.scss';
import { LanguageSelect as LanguageSelectV1 } from '@securitize/ui-components';

const LanguageSelect = () => <LanguageSelectV1 />;

export default LanguageSelect;
